import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/Icon";
import { GAME_SPECS } from "@/lib/gameSpecs";

// Per-game disclosure surface (Game Rules §7): objective, payouts, key rules,
// fairness, and interruption handling — shown before/while playing each game.
export default function GameRulesModal({ gameKey, onClose }) {
  const spec = gameKey ? GAME_SPECS[gameKey] : null;
  if (!spec) return null;
  return (
    <div className="fixed inset-0 z-[9998] flex items-end justify-center bg-black/70 p-0 sm:items-center sm:p-4"
      data-testid="game-rules-modal" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="max-h-[85vh] w-full max-w-lg overflow-y-auto rounded-t-2xl border border-[#27272A] bg-[#141417] p-5 sm:rounded-2xl">
        <div className="mb-3 flex items-start justify-between gap-3">
          <div>
            <h2 className="font-display text-xl font-black tracking-tight text-white">{spec.title}</h2>
            <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wide text-[#00D632]">{spec.provider}</p>
          </div>
          <button aria-label="Close" onClick={onClose} className="text-[#71717a] hover:text-white"><Icon name="x" size={18} /></button>
        </div>

        <p className="text-sm leading-relaxed text-[#a1a1aa]">{spec.objective}</p>

        <div className="mt-4 overflow-hidden rounded-xl border border-[#27272A]">
          {spec.rows.map(([k, v]) => (
            <div key={k} className="flex items-start justify-between gap-4 border-b border-[#1F1F23] px-4 py-2.5 last:border-0">
              <span className="text-xs font-semibold text-[#a1a1aa]">{k}</span>
              <span className="text-right text-xs text-white">{v}</span>
            </div>
          ))}
        </div>

        {spec.payouts?.length > 0 && (
          <div className="mt-4">
            <p className="mb-1 text-xs font-bold uppercase tracking-wide text-[#a1a1aa]">Payouts</p>
            <ul className="ml-4 list-disc space-y-0.5 text-sm text-[#a1a1aa]">
              {spec.payouts.map((p, i) => <li key={i}>{p}</li>)}
            </ul>
          </div>
        )}

        <div className="mt-4 flex gap-2 rounded-xl border border-surface-border bg-surface-5 p-3">
          <Icon name="shield-check" size={16} className="mt-0.5 shrink-0 text-[#00D632]" />
          <p className="text-xs leading-relaxed text-[#a1a1aa]">{spec.fairness}</p>
        </div>

        <p className="mt-4 text-xs leading-relaxed text-[#71717a]">
          Settlement, voids, and interruption handling follow the{" "}
          <Link to="/game-rules" onClick={onClose} className="text-[#00D632] underline underline-offset-2 hover:text-white">Sports &amp; Casino Game Rules</Link>. Play responsibly — 18+.
        </p>
      </div>
    </div>
  );
}
